
export const featureCardStyles = `
  @property --rotate {
    syntax: "<angle>";
    initial-value: 132deg;
    inherits: false;
  }

  .feature-card {
    position: relative;
    padding: 1px;
    border-radius: 1rem;
    transform-style: preserve-3d;
    perspective: 1000px;
    transition: filter 0.3s ease;
    will-change: transform;
  }

  .feature-card::before {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    background-image: linear-gradient(
      var(--rotate), 
      #f94933,
      #9333ea,
      #2563eb
    );
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    animation: spin 2.5s linear infinite;
    backface-visibility: visible;
    transition: filter 0.3s ease;
  }

  .feature-card:hover::before {
    filter: brightness(1.2);
  }

  .feature-card::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    transform: scale(1.01);
    filter: blur(8px);
    background-image: linear-gradient(
      var(--rotate), 
      #f94933,
      #9333ea,
      #2563eb
    );
    opacity: 0.5;
    transition: opacity 0.3s ease, filter 0.3s ease, transform 0.3s ease;
    animation: spin 2.5s linear infinite;
    border-radius: 1rem;
    backface-visibility: visible;
  }

  .feature-card:hover::after {
    opacity: 0.7;
    filter: blur(12px);
    transform: scale(1.02);
  }

  .feature-card-content {
    position: relative;
    z-index: 1;
    background: rgba(0, 0, 0, 0.95);
    height: 100%;
    width: 100%;
    padding: 2rem;
    border-radius: calc(1rem - 1px);
    backface-visibility: hidden;
    transition: transform 0.3s ease, background 0.3s ease;
    transform-style: preserve-3d;
  }

  .feature-card:hover .feature-card-content {
    background: rgba(0, 0, 0, 0.85);
  }

  @keyframes spin {
    0% {
      --rotate: 0deg;
    }
    100% {
      --rotate: 360deg;
    }
  }
`;
